export const SearchTypeRelatedAssets = 11 as const;
export type TSearchTypeRelatedAssets = typeof SearchTypeRelatedAssets;
